import * as info from "info";
import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { getUserId } from "../../../adblock-betafish/id/background/index";
import { License } from "../../../adblock-betafish/picreplacement/check";
import { Prefs } from "../../../adblock-betafish/alias/prefs";
export async function getInjectionInfo() {
    var _a;
    await Promise.all([Prefs.untilLoaded, License.ready()]);
    const [isPremium, id, experimentFlags, trial] = await Promise.all([
        License.isActiveLicense(),
        getUserId(),
        ewe.experiments.getFlags(),
        ewe.account.getTrial(),
    ]);
    const isTrial = (_a = trial === null || trial === void 0 ? void 0 : trial.ab) !== null && _a !== void 0 ? _a : false;
    const version = info.addonVersion;
    const blockCount = Prefs.get("blocked_total");
    return { isPremium, isTrial, version, id, blockCount, experimentFlags };
}
